import { render } from "./ViewPdf.vue?vue&type=template&id=614f12b9&scoped=true"
import script from "./ViewPdf.vue?vue&type=script&lang=js"
export * from "./ViewPdf.vue?vue&type=script&lang=js"

import "./ViewPdf.vue?vue&type=style&index=0&id=614f12b9&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-614f12b9"

export default script